<template>
    <div class="sidebar">
        <div class="logo-container">
            <img src="../assets/logo.png" alt="METO Logo" class="logo">
        </div>
        <div class="menu">
            <div class="menu-title">历史对话</div>
            <div class="menu-con" v-infinite-scroll="getConversationList" infinite-scroll-distance="50" infinite-scroll-disabled="disabled">
                <div :class="['menu-item', item.id === curId && 'actived']" v-for="(item, index) in recentDialogs"
                    :key="item.id" @click="changeCur(item.id)">
                    <span class="menu-item-title">- {{ item.title }}</span>
                    <span class="icon" @click="close(item)"><i class="el-icon-close"></i></span>
                </div>
            </div>
        </div>
        <img src="../assets/addBtn.png" class="add-btn" alt="" @click="$emit('changeCurId', null)">
    </div>
</template>

<script>
import {
  listConversation,
  delConversationMsg
} from '@/api/index'
import { EventBus } from '@/eventBus'
import { isSessionLoggedIn, getStoredUser } from '@/utils/userSession'
export default {
    name: 'SidebarComponent',
    props: {
        curId: {
            default: null
        },
        isLoading: {
            default: false
        }
    },
    data() {
        return {
            recentDialogs: [],
            params: {
                pageNum: 1,
                pageSize: 10
            },
            loading: false,
            isFinish: false,
            sessionVersion: 0,
        }
    },
    computed: {
        disabled () {
            return this.loading || this.isFinish || !this.isLogin
        },
        isLogin() {
            void this.sessionVersion
            return isSessionLoggedIn()
        },
        user() {
            void this.sessionVersion
            return getStoredUser() || {}
        },
    },
    mounted() {
        this.init()
    },
    created() {
        this._onUserSessionUpdated = () => {
            this.sessionVersion += 1
            if (isSessionLoggedIn()) {
                this.init()
            } else {
                this.recentDialogs = []
            }
        }
        EventBus.$on('user-session-updated', this._onUserSessionUpdated)
    },
    beforeDestroy() {
        EventBus.$off('user-session-updated', this._onUserSessionUpdated)
    },
    methods: {
        init() {
            this.recentDialogs = []
            this.isFinish = false
            this.params.pageNum = 1
            this.getConversationList()
        },
        // 加载会话列表
        getConversationList() {
            if (this.loading || !this.isLogin || this.isFinish) return
            this.loading = true
            listConversation(this.user.nickName).then(({data}) => {
                // 获取data的属性数量
                const total = Object.keys(data).length;
                Object.keys(data).forEach(key => {
                    const msgs = data[key]
                    this.recentDialogs.push({
                        id: key,
                        title: msgs[0].content
                    })
                })
              this.recentDialogs.reverse();
              this.loading = false
                this.params.pageNum += 1
                this.isFinish = this.recentDialogs.length === total
            }).catch(() => {
                this.loading = false
            })
        },
        // 删除会话
        close(item) {
            if (this.isLoading) return
            delConversationMsg(this.user.nickName, item.id).then(() => {
                this.$message.success('删除成功')
                if (this.curId === item.id) {
                    this.$emit('delCurId')
                }
                this.init()
            }).catch(() => {})
        },
        // 切换会话，未选中时为新建
        changeCur(id) {
            this.$emit('changeCurId',this.curId === id ? null : id)
        }
    }
}
</script>

<style scoped lang="scss">
.sidebar {
    height: 100%;
    padding: 62px 40px 75px;

    .logo {
        width: 197px;
        height: 41px;
        margin-right: 10px;
    }

    .menu {
        margin-top: 70px;
        height: calc(100% - 200px);

        &-title {
            font-weight: 600;
            font-size: 18px;
            color: #000000;
            line-height: 25px;
            position: relative;
            padding-left: 11px;

            &::before {
                content: '';
                display: block;
                width: 2px;
                height: 14px;
                background-color: #EE9803;
                position: absolute;
                left: 0;
                top: 5px;
            }
        }

        &-con {
            height: calc(100% - 120px);
            overflow: auto;

            .menu-item {
                margin-top: 20px;
                font-size: 14px;
                color: #222222;
                padding-left: 25px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                &-title {
                    flex: 1;
                    margin-right: 8px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .icon {
                    display: none;
                }

                &.actived {
                    background-color: #fff;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    border-radius: 12px;
                    padding-right: 10px;

                    .icon {
                        display: block;
                    }
                }
            }
        }
    }

    .add-btn {
        width: 256px;
        height: 48px;
    }
}

@media (max-width: 768px) {
    .sidebar {
        padding: 28px 18px 28px;

        .logo {
            width: 156px;
            height: auto;
            margin-right: 0;
        }

        .menu {
            margin-top: 32px;
            height: calc(100% - 116px);

            &-title {
                font-size: 16px;
                line-height: 22px;
            }

            &-con {
                height: calc(100% - 74px);

                .menu-item {
                    margin-top: 12px;
                    padding-left: 14px;
                    font-size: 13px;

                    &.actived {
                        padding-top: 9px;
                        padding-bottom: 9px;
                        border-radius: 10px;
                    }
                }
            }
        }

        .add-btn {
            width: 100%;
            max-width: 240px;
            height: auto;
            display: block;
        }
    }
}
</style>
